// extracted by mini-css-extract-plugin
export default {"snackbarRoot":"App_snackbarRoot__0JqNA","snackbar":"App_snackbar__KKVpG"};